// Textos que saem pelo WhatsApp do entregador ou da loja. Variam por loja no futuro
// (configuração); por enquanto são os padrões.

export function primeiroNome(nome: string): string {
  return nome.trim().split(/\s+/)[0] ?? '';
}

export function mensagemSaiuParaEntrega(dados: {
  clienteNome: string;
  lojaNome: string;
  linkRastreio: string;
}): string {
  const nome = primeiroNome(dados.clienteNome);
  const saudacao = nome ? `Oi, ${nome}!` : 'Oi!';
  return `${saudacao} Seu pedido da ${dados.lojaNome} saiu para entrega. Acompanhe por aqui: ${dados.linkRastreio}`;
}

export function urlRastreio(baseUrl: string, token: string): string {
  return `${baseUrl.replace(/\/+$/, '')}/r/${token}`;
}
